/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BridgeApiAddParticipantToConversation
 */
export interface BridgeApiAddParticipantToConversation {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiAddParticipantToConversation
     */
    organisationId: string;
}

/**
 * Check if a given object implements the BridgeApiAddParticipantToConversation interface.
 */
export function instanceOfBridgeApiAddParticipantToConversation(value: object): value is BridgeApiAddParticipantToConversation {
    if (!('organisationId' in value) || value['organisationId'] === undefined) return false;
    return true;
}

export function BridgeApiAddParticipantToConversationFromJSON(json: any): BridgeApiAddParticipantToConversation {
    return BridgeApiAddParticipantToConversationFromJSONTyped(json, false);
}

export function BridgeApiAddParticipantToConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiAddParticipantToConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'organisationId': json['organisationId'],
    };
}

export function BridgeApiAddParticipantToConversationToJSON(json: any): BridgeApiAddParticipantToConversation {
    return BridgeApiAddParticipantToConversationToJSONTyped(json, false);
}

export function BridgeApiAddParticipantToConversationToJSONTyped(value?: BridgeApiAddParticipantToConversation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organisationId': value['organisationId'],
    };
}

